import { Box, Typography } from "@mui/material";
import { Fragment } from "react";

const WorkExperienceBadge = ({ logoUrl, title, subtitle, dateRange, ref }) => {
  return (
    <Box
      px={3}
      py={1}
      maxWidth="100%"
      sx={{
        display: "flex",
        flex: 1,
        alignItems: "center",
        gap: "1rem",
        background: "#fff",
        border: "1px solid #e5e5e5",
        marginBottom: "1rem",
        borderRadius: 50,
      }}
    >
      <img
        src={logoUrl}
        alt={logoUrl}
        width="44px"
        style={{
          borderRadius: 100,
          boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
        }}
      />
      <Box py={1} mr={4}>
        <Typography variant="subtitle2">
          {title.split("\n").map((line, index) => (
            <Fragment key={index}>
              {line}
              <br />
            </Fragment>
          ))}
        </Typography>
        <Typography variant="subtitle2" sx={{ fontWeight: "Bold" }}>
          {subtitle}
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ ml: "auto" }} ref={ref}>
        {dateRange}
      </Typography>
    </Box>
  );
};

export default WorkExperienceBadge;
